
		<span *ngIf="item else empty">
			<a [href]="item.multimediaCDN.url" target="_blank">{{item.name}}</a>
		</span>

		<ng-template #empty>
			<div class="table-empty" i18n="@@no-record">record not found</div>
		</ng-template>
	